import React from 'react';
import { Row } from '@yme/atoms/grid';
import { SEPARATOR_DATA_TEST_ID } from './constants';
import { SeparatorWrapper, ColStyled, ContainerStyled } from './styled';
export function Separator({ isAddTopLine }) {
    return (React.createElement(SeparatorWrapper, { "data-testid": SEPARATOR_DATA_TEST_ID }, isAddTopLine && (React.createElement(ContainerStyled, { width: "100%" },
        React.createElement(Row, null,
            React.createElement(ColStyled, null))))));
}
Separator.displayName = 'Separator_AEMComponent';
